import { render } from "./dealersalesreport_form.vue?vue&type=template&id=3c60b679&scoped=true"
import script from "./dealersalesreport_form.vue?vue&type=script&lang=js"
export * from "./dealersalesreport_form.vue?vue&type=script&lang=js"

import "./dealersalesreport_form.vue?vue&type=style&index=0&id=3c60b679&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c60b679"]])

export default __exports__